import classNames from 'classnames';
import React from 'react';

import trans from 'common/tools/translations/trans';

import styles from './styles.module.scss';

type MidnightBadgeProps = {
  className?: string;
  iconOnly?: boolean;
};

const MidnightBadge = ({ className, iconOnly = false }: MidnightBadgeProps) => {
  const label = trans('showtimes.midnight_screening');

  if (iconOnly) {
    // no visible text: the label stays available to screen readers and as a tooltip
    return (
      <span
        aria-label={label}
        className={classNames(styles.badgeIcon, className)}
        role="img"
        title={label}
      />
    );
  }

  return <span className={classNames(styles.badge, className)}>{label}</span>;
};

export default MidnightBadge;
